// const toCurrency =  (input) => {
//   input.parentNode.setAttribute("comma-value", Number(input.value??0).toLocaleString(navigator.language, { minimumFractionDigits: 0 }));
// };
// // const resetInput=(e)=>{
// //   const input = e.target;
// //   input.parentNode.setAttribute("comma-value", 0); 
// // }
// const selectText = (e)=>{
//   e.target.select();
// }
// function NewNumberInput(props) {
//   const { inputname, onChange, defaultValue, minvalue, value, customattr, readonly, reff, className, style, containerStyle, containerClassName, step, id } = props;
//   const currency = Number(value ? value : (defaultValue ?? "0")).toLocaleString(navigator.language, { minimumFractionDigits: 0 });
//   return (
//     <div id={"comma_" + inputname} comma-value={currency} style={containerStyle} className={containerClassName}>
//       {value !== undefined &&
//         <input type="number" id={id} name={inputname} ref={reff} readOnly={readonly} className={(className ?? "") + " form-control"}
//         onChange={(e) => { toCurrency(e.target); if (onChange) { onChange(e); } }} value={value} min={minvalue} {...customattr} style={style} step={step??1} onFocus={selectText}/>
//       }
//       {defaultValue !== undefined && value === undefined &&
//         <input type="number" id={id} name={inputname} ref={reff} readOnly={readonly} className={(className ?? "") + " form-control"}
//         onChange={(e) => { toCurrency(e.target); if (onChange) { onChange(e); } }} defaultValue={defaultValue} min={minvalue} {...customattr} style={style} step={step??1}  onFocus={selectText}/>
//       }
//       {defaultValue === undefined && value === undefined &&
//         <input type="number" id={id} name={inputname} ref={reff} readOnly={readonly} className={(className ?? "") + " form-control"}
//         onChange={(e) => { toCurrency(e.target); if (onChange) { onChange(e); } }} min={minvalue} {...customattr} style={style} step={step??1}  onFocus={selectText}/>
//       }
//     </div>
//   )
// }
import { useState, useEffect } from 'react';

function NewNumberInput(props) {
  const {
    inputname,
    onChange,
    defaultValue,
    minvalue,
    value,
    customattr,
    readonly,
    reff,
    className,
    style,
    containerStyle,
    containerClassName,
    placeholder,
    step,
    id
  } = props;

  const [rawValue, setRawValue] = useState('');
  const [formattedValue, setFormattedValue] = useState('');

  const formatNumber = (val) => {
    if (!val) return '';
    const parts = val.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '٬');
    return parts.join('.');
  };

  const cleanInput = (val) => {
    return val?.toString().replace(/[^0-9٫.]/g, '')?.replace(/٫/g, '.');
  };

  useEffect(() => {
    const initial = cleanInput(value ?? defaultValue ?? '');
    setRawValue(initial);
    setFormattedValue(formatNumber(initial));
  }, [value, defaultValue]);

const handleChange = (e) => {
  const inputValue = e.target.value;
  let rawValue = cleanInput(inputValue);

  // کنترل minValue اگر تعریف شده بود
  if (minvalue !== undefined && rawValue !== '') {
    const numericValue = parseFloat(rawValue);
    if (numericValue < props.minValue) {
      rawValue = props.minValue.toString();
    }
  }

  setRawValue(rawValue);
  setFormattedValue(formatNumber(rawValue));

  if (onChange) {
    const syntheticEvent = {
      ...e,
      target: {
        ...e.target,
        value: rawValue,
        name:inputname
      },
      preventDefault: () => e.preventDefault(),
      stopPropagation: () => e.stopPropagation(),
      nativeEvent: e.nativeEvent,
      currentTarget: e.currentTarget,
    };

    onChange(syntheticEvent);
  }
};




  return (
    <div /*id={"comma_" + inputname} comma-value={formattedValue}*/ style={containerStyle} className={containerClassName}>
      <input
        type="text"
        inputMode="decimal"        
        name={inputname?inputname + "_view":null}
        readOnly={readonly}
        className={`${className?.replace("!","") ?? ''}${className?.contains("!")?"": ' form-control'}`}
        value={formattedValue}
        onChange={handleChange}
        onFocus={(e) => e.target.select()}
                placeholder={placeholder}
        style={style}
      />
      {/* مقدار مخفی بدون فرمت برای استفاده در فرم‌ها یا سرور */}
      <input type="hidden" name={inputname} value={rawValue} ref={reff} id={id} {...customattr}/>
    </div>
  );
}

export default NewNumberInput;

//export default NewNumberInput;